import { DefaultRequest } from 'scripts/api';
import { actionCreators } from 'react/api/actions/tabs';

class RouteDetailsRouter extends App.Routers.BaseRouter {
  constructor() {
    const entityName = "RouteDetails";

    super(entityName);

    this.map = "";
    this.routeLayer = "";
    this.actualRouteLayer = "";
    this.routeId = "";
    this.eventId = "";
    this.closeActions = [];

    App.Objects.RouteDetails = this;
    if (!Monet.Session.RouteDetail) {
      Monet.Session.RouteDetail = {
        screensList: []
      };
    }
  }

  addRouteToCriteriaChain = (criteriaChain, routeId) => {
    criteriaChain.criteriaChain[0].and.push({
      attr: "route.id",
      eq: parseInt(routeId, 10)
    });
  };

  getFilter = () => {
    var criteriaChain,
      _entity = this.entityName,
      _routeId = this.routeId,
      filterBuilder = App.Forms[_entity].filterBuilder;

    if (!filterBuilder) {
      filterBuilder = new Monet.UI.FilterBuilder();
      filterBuilder.setEntity("RouteDetail");
      filterBuilder.setCustomNameSpace(_entity);
    }

    criteriaChain = filterBuilder.getCriteriaChain();

    var sort = filterBuilder.getSort();

    this.addRouteToCriteriaChain(criteriaChain, _routeId);

    if (typeof sort !== "undefined" && sort.length !== 0) {
      criteriaChain.sort = sort;
    }

    return criteriaChain;
  };

  getRouteData = (routeId, callback) => {
    var getRouteData = (function (routeId, callback) {
      return function () {
        // Obtendo os dados da rota.
        Monet.Session.Grids.Route.data = new App.Collections.Routes();

        Monet.Session.Grids.Route.data.filterWithCriteria({
          filter: {
            criteriaChain: [
              {
                and: [
                  {
                    attr: "id",
                    eq: routeId
                  }
                ]
              }
            ]
          },
          criteria:
            '{"filters":["*", "organization.id", "organization.description","origin.*", "destination.*", "driverAssignments.*", "driverAssignments.driver.*", "equipmentAssignments.equipment.*", "equipmentAssignments.equipment.id", "equipmentAssignments.equipment.key", "equipmentAssignments.principal","equipmentAssignments.equipment.gpsProvider.id","proactiveRouteOptConfig"]}',
          success: function(data) {
            callback(data);
          }
        });
      };
    })(routeId, callback);

    if (!Monet.Session.Grids.Route.data) {
      getRouteData();
    } else {
      if (!Monet.Session.Grids.Route.data.getById(routeId)) {
        getRouteData();
      } else {
        callback(Monet.Session.Grids.Route.data);
      }
    }
  };

  checkRoutePath = callback => {
    (function (context) {
      const request = new DefaultRequest({
        url: "Route/" + context.routeId + "/GeneratePath",
        success: function () {
          var columnProvider = new Greenmile.RouteDetail.ColumnsToGrid();
          columnProvider.setEntity("RouteDetails_" + context.routeId);
          columnProvider.getFieldsToGridLayout(function () {
            context.getRouteData(context.routeId, callback);
          });
        }
      });
      request.send();
    })(this);
  };

  getProjection = () => {
    var tableLayout, projectionBuilder;

    tableLayout = App.Forms[this.entityName].layout.index;

    projectionBuilder = new Monet.Builder.Projection();
    projectionBuilder.setLayout(tableLayout);
    projectionBuilder.parseLayout();
    projectionBuilder.addFields([
      { name: "*" },
      { name: "stop.*" },
      { name: "stop.location.*" },
      { name: "stop.location.locationType.*" },
      { name: "stop.stopType.*" },
      { name: "stop.cancelCode.*" },
      { name: "stop.redeliveryStop.*" },
      { name: "stop.redeliveryStop.location.key*" },
      { name: "stop.undeliverableCode.*" },
      { name: "stop.actualArrival" },
      { name: "stop.actualCancel" },
      { name: "stop.confirmedAsNextStop" },
      { name: "stop.cloneDate" },

      { name: "route.*" },
      { name: "route.origin.*" },
      { name: "route.origin.organization.*" },
      { name: "route.origin.locationType.*" },
      { name: "route.origLatitude" },
      { name: "route.origLongitude" },

      { name: "route.destination.*" },
      { name: "route.destLatitude" },
      { name: "route.destLongitude" },
      { name: "route.destination.organization.*" },
      { name: "route.destination.locationType.*" },
      { name: "route.proactiveRouteOptConfig" }
    ]);

    projectionBuilder.addFieldsToIncluding(["geofence"]);

    return projectionBuilder.projection.toString();
  };

  getStopsByRestrictions = (filter, appendCollection, callback) => {
    var stopCollection = new App.Collections.StopViews(),
      _filter = {},
      projection = this.getProjection();
    if (filter) {
      _filter = filter;
    }
    if (appendCollection) {
      stopCollection.reset();
    }

    stopCollection.filterWithRestrictions({
      filter: _filter,
      criteria: projection,
      success: result => {
        if (callback) {
          callback(result);
        }
      }
    });
  };

  getResequenceHistory = (routeId, map, stops, callback) => {
  const ajax = new Monet.Ajax();
  ajax.url = `ProactiveRouteOpt/${routeId}`;

  ajax.success = (resequenceHistoryData) => {
    if (Array.isArray(resequenceHistoryData)) {
      resequenceHistoryData.forEach((item, index) => {
        if (item.optimizationId) {
          item.optimizationId = `${item.optimizationId}_${index}`;
        }
      });
    }

    callback.showStopsAndLogBook(routeId, map, stops, resequenceHistoryData);
  };
  ajax.error = () => {
    callback.showStopsAndLogBook(routeId, map, stops);
  };
  ajax.send();
  };

  getRouteId = () => {
    return this.routeId;
  };

  showOnEventFocus = (routeId, eventId) => {
    this.setEventId(eventId);
    this.show(routeId);
  };

  setEventId = id => {
    this.eventId = id;
  };

  focusOnTheStop = (stopId, map) => {
    if (!stopId) return;

    const dataModels = Monet.Session.RouteDetail.screensList[this.routeId].stops.data;

    if (dataModels?.size?.()) {
      const models = dataModels.models.filter(
        model => model.attributes.stop.id === parseInt(stopId, 10)
      );
      const stopToFocus = models?.[0]?.attributes?.stop ?? {};

      map.focusOnTheStop(stopToFocus);
    }

  };

  initDates = () => {
    const { tabSelector, model } = Monet.Session.RouteDetail.screensList[this.routeId];
    const beginDateRoutePlay = document.querySelector(tabSelector + " input[name='routePlay_initialDate']");
    const endDateRoutePlay = document.querySelector(tabSelector + " input[name='routePlay_finalDate']");

    let initialDate, finalDate;

    if (beginDateRoutePlay && beginDateRoutePlay.value) {
      initialDate = Monet.Format.DateTime.parseLocale(beginDateRoutePlay.value);
    } else {
      initialDate = Monet.Format.DateTime.parse(model.actualStart || model.plannedStart);
    }

    if (endDateRoutePlay && endDateRoutePlay.value) {
      finalDate = Monet.Format.DateTime.parseLocale(endDateRoutePlay.value);
    } else if (model.actualComplete) {
      finalDate = Monet.Format.DateTime.parse(model.actualComplete);
    } else {
      finalDate = Monet.Format.DateTime.parse(initialDate, { daysOffset: 2 });
    }

    const interval = {
      beginDate: initialDate,
      endDate: finalDate,
      inputStartValue: Monet.Format.DateTime.formatToLocale(initialDate),
      inputEndValue: Monet.Format.DateTime.formatToLocale(finalDate)
    };

    if (beginDateRoutePlay && interval.inputStartValue) {
      beginDateRoutePlay.value = interval.inputStartValue;
    }

    if (endDateRoutePlay && interval.inputEndValue) {
      endDateRoutePlay.value = interval.inputEndValue;
    }

    return interval;
  };

  show = (routeId, stopId) => {
    this.setRouteId(routeId);
    this.setStopId(stopId);

    this.createGreenmileSessionsToRouteDetail(routeId);

    const initMap = () => {
      const screen = Monet.Session.RouteDetail.screensList[this.routeId];
      const mapRouteDetail = new Greenmile.RouteDetail.Map(this.routeId);

      const routeSelected = screen.model;
      if (stopId) {
        Monet.Session.RouteDetail.screensList[this.routeId].selectedStopId = stopId;
      }

      App.Forms[
        "RouteDetails_" + this.routeId
      ].eventsRoute = new Greenmile.EventLog.Manager(routeSelected, null);

      this.map = mapRouteDetail.startMap();

      this.markerStops = new Greenmile.RouteDetail.MarkerStop(
        this.map,
        this.routeId
      );
      const eventRoute = new Greenmile.RouteDetail.EventRoute(
        this.map,
        this.routeId
      );
      const actualRoute = new Greenmile.RouteDetail.InfoRoute(
        this.map,
        this.routeId
      );
      const radius = new Greenmile.RouteDetail.StopRadius(
        this.map,
        this.routeId
      );
      const expandedRadius = new Greenmile.RouteDetail.StopRadius(
        this.map,
        this.routeId
      );
      const plannedRoute = new Greenmile.RouteDetail.PlannedRoute();
      const baselinePlannedRoute = new Greenmile.RouteDetail.BaselinePlannedRoute();
      const markerSignatures = new Greenmile.RouteDetail.MarkerSignature(
        this.map,
        this.routeId
      );
      const markerArrivals = new Greenmile.RouteDetail.MarkerArrival(
        this.map,
        this.routeId
      );
      const markerDepartures = new Greenmile.RouteDetail.MarkerDeparture(
        this.map,
        this.routeId
      );
      const selector = `#routeMaps_${this.routeId} #mapCon`;
      const mapHOSEvents = new Greenmile.HoursOfService.MapEvents(
        "#routeMaps_" + this.routeId
      );
      const fitToBounds = this.eventId ? false : true;
      let showEquipmentOff = false;

      screen.eventRoute = eventRoute;
      screen.mapRouteDetail = mapRouteDetail;

      plannedRoute.setMap(this.map);
      plannedRoute.setRouteId(this.routeId);

      baselinePlannedRoute.setMap(this.map);
      baselinePlannedRoute.setRouteId(this.routeId);

      const routePlayBeforeStartPlay = () =>
        App.Views.RouteDetails.hideTabInformation(
          `#routeMaps_${this.routeId}`,
          this.routeId
        );

      const getCoordinates = loadEvents => {
        const afterGetCoordinates = equipment => {
          if (
            screen.editingStop &&
            screen.equipment &&
            screen.equipment.key === equipment.key
          ) {
            const stop = screen.editingStop.stop;
            new Greenmile.RouteDetail.SuggestGeocodeStop(
              this.routeId,
              screen.map,
              screen
            )
              .setData(stop)
              .render()
              .getSuggestionAndRenderResult();
          }
          if (showEquipmentOff) {
            const strLayerEquipOff = `#routeMaps_${this.routeId} #inputEquipOff`;
            const fieldEquipmentOff = document.querySelector(strLayerEquipOff);
            const minutes = fieldEquipmentOff
              ? parseInt(fieldEquipmentOff.value, 10) || 0
              : 0;
            const coordinatesFiltered = screen.coordinates.filterCoordinatesByEquipmentStoppedByMinutes(
              minutes
            );

            if (coordinatesFiltered.length) {
              applyEquipmentOffFilter(coordinatesFiltered);
            }
          }
        };
        screen.canShowLayerCoordinates = true;
        actualRoute.getCoordinatesAndDrawOnMap(afterGetCoordinates, loadEvents);
      };

      const applyEquipmentOffFilter = coordinatesFiltered => {
        if (coordinatesFiltered) {
          showEquipmentOff = true;
          if (screen.editingStop) {
            new Greenmile.RouteDetail.SuggestGeocodeStop(
              this.routeId,
              this.map,
              screen
            )
              .setData(screen.editingStop.stop)
              .renderSuggestionByEquipmentStoppedAndRenderOnMap(
                coordinatesFiltered
              );
          } else {
            new Greenmile.Marker.EquipmentInOff(this.map, this.routeId)
              .setData(coordinatesFiltered)
              .render();
          }
        } else {
          showEquipmentOff = false;
        }
      };

      const updateMapFilter = loadEvents => {
        if (!Monet.Session.RouteDetail.screensList[this.routeId]) return;

        getCoordinates(loadEvents);

        const sourceData = Monet.Session.RouteDetail.screensList[this.routeId];
        const hosCollection = sourceData.listHos;
        mapHOSEvents.drawMarkers(hosCollection, this.map, false);
      };

      const options = {
        layersToEnable: [
          {
            layer: Greenmile.Toolbar.MapLayers.STOPS,
            instanceDataClass: this.markerStops
          },
          {
            layer: Greenmile.Toolbar.MapLayers.MULTI_ROUTE,
            instanceDataClass: actualRoute
          },
          {
            layer: Greenmile.Toolbar.MapLayers.PLANNED_ROUTE,
            instanceDataClass: plannedRoute
          },
          {
            layer: Greenmile.Toolbar.MapLayers.BASELINE_PLANNED_ROUTE,
            instanceDataClass: baselinePlannedRoute
          },
          {
            layer: Greenmile.Toolbar.MapLayers.RADIUS_ROUTE,
            instanceDataClass: radius
          },
          {
            layer: Greenmile.Toolbar.MapLayers.EXPANDED_RADUIS,
            instanceDataClass: expandedRadius
          },
          {
            layer: Greenmile.Toolbar.MapLayers.EVENT_ROUTE,
            instanceDataClass: eventRoute
          },
          {
            layer: Greenmile.Toolbar.MapLayers.SIGNATURES,
            instanceDataClass: markerSignatures
          },
          {
            layer: Greenmile.Toolbar.MapLayers.ARRIVAL,
            instanceDataClass: markerArrivals
          },
          {
            layer: Greenmile.Toolbar.MapLayers.DEPARTURE,
            instanceDataClass: markerDepartures
          }
        ],
        routeId: this.routeId,
        sourceSessionData: screen,
        routePlay: {
          beforeStartPlay: routePlayBeforeStartPlay,
          afterChangeDate: updateMapFilter
        },
        equipmentOff: {
          onClickFilter: applyEquipmentOffFilter
        }
      };

      screen.toolbarSelector = "#routeMaps_" + this.routeId;

      const help = new Monet.UI.Help(
        "RouteDetail",
        Monet.I18n.getResourcesByKey("CustomTabs.tabName.Route")
      );
      const toolbar = new Greenmile.Toolbar.Map(
        this.map,
        selector,
        options,
        help
      );

      toolbar.enable([
        toolbar.actions.searchAddressOnMap,
        toolbar.actions.street,
        toolbar.actions.fitToMarkers,
        toolbar.actions.focusEquipment,
        toolbar.actions.zoom,
        toolbar.actions.source,
        toolbar.actions.points,
        toolbar.actions.coords,
        toolbar.actions.pois,
        toolbar.actions.hos,
        toolbar.actions.layer,
        toolbar.actions.routePlayer,
        toolbar.actions.geofences,
        toolbar.actions.equipmentOff
      ]);

      toolbar.setAfterRenderToolbar(() => {
        const storage = new Greenmile.Storage.StoreMapPosition();
        const check = storage.getLayerMapFromUser();

        if (check.planned_route) {
          plannedRoute.drawPlannedRoute();
        }

        if (check.actual_route) {
          getCoordinates();
        }

        if (check.baseline_planned_route) {
          baselinePlannedRoute.drawBaselinePlannedRoute();
        }

        const callbackAfterDrawStops = () => {
          if (!stopId) {
            this.markerStops.setFitToBounds(fitToBounds);
            this.markerStops.fitBoundsToStopsCoords();
          }

          if (!Monet.Session.RouteDetail.screensList[this.routeId]) return;
          if (check.radius_route) {
            radius.drawRadiusFromStop();
          }

          if (check.expanded_radius_route) {
            radius.drawExpandedRadiusFromStop();
          }

          this.focusOnTheStop(stopId, mapRouteDetail);

          if (Monet.Session.RouteDetail.screensList[routeId]?.route
              && (check.event_route || this.eventId)) {
            Monet.Session.RouteDetail.screensList[
              routeId
            ].router.eventId = this.eventId;
            eventRoute.requestEventsAndAddOnMap();
          }

          if (!check.stops && fitToBounds) {
            new Greenmile.Toolbar.Map.FitToMarkers(
              screen.toolbarSelector,
              this.map
            ).showAllMarkers();
          }

          if (Monet.Session?.RouteDetail?.ShortStopDetailsModal?.stopId) {
            const stopSelection = new Greenmile.RouteDetail.StopSelection(this.routeId);
            stopSelection.selectOrDeselectStop(Monet.Session.RouteDetail.ShortStopDetailsModal.stopId);
            delete Monet.Session.RouteDetail.ShortStopDetailsModal;
          }
        };

        const callbackAfterGetStops = dataGridStops => {
          if (!Monet.Session.RouteDetail.screensList[this.routeId]) return;
          const hasPro =
            dataGridStops.first() &&
            dataGridStops.first().attributes.route.proactiveRouteOptConfig &&
            Greenmile.Utils.hasResequenceHistoryPermission();

          Monet.Session.RouteDetail.screensList[this.routeId] = Monet.Session.RouteDetail.screensList[this.routeId] || {};
          Monet.Session.RouteDetail.screensList[this.routeId].hasPRO = hasPro;

          if (hasPro) {
            this.getResequenceHistory(
              this.routeId,
              this.map,
              dataGridStops,
              App.Views.RouteDetails
            );
          } else {
            App.Views.RouteDetails.showStopsAndLogBook(
              this.routeId,
              this.map,
              dataGridStops
            );
          }

          this.markerStops.removeStopsFromMap();
          this.markerStops.getStopsAndDrawOnMap(callbackAfterDrawStops);
        };

        this.getStopsByRestrictions(
          this.getFilter(),
          true,
          callbackAfterGetStops
        );
      });

      toolbar.render();
      this.initDates();
    };

    this.checkRoutePath(routeCollection => {
      // cria a tab para o detalhe da rota
      const createTabRoute = (function (
        routeId,
        routeCollection
      ) {
        return function () {
          const route = routeCollection.getById(routeId);

          if (!route) {
            new Greenmile.Components.AlertModal(
              'Greenmile.message.routeNotFound'
            ).show();

            const error = new Monet.Exception.ReturnError(
              this,
              'There no route with id(' + routeId + ') in routes collection'
            );
            error.console();
            return;
          }

          if (Monet.Session.RouteDetail.screensList[routeId]) {
            Monet.Session.RouteDetail.screensList[routeId].equipment = {};
            Monet.Session.RouteDetail.screensList[routeId].equipments = {};
            Monet.Session.RouteDetail.screensList[routeId].model =
              route.attributes;
          }

          const tabName = `routeMaps_${routeId}`;
          const mapContainer = `routeMapContainer_${routeId}`;
          const resource = Monet.I18n.getResourcesByKey(
            'CustomTabs.tabName.Route'
          );

          window.globalStore.dispatch(
            actionCreators.updateTitle({
              key: `RouteDetails_${route.get('id')}`,
              title: `${resource} (${route.get('key')})`
            })
          );

          const setEquipmentInfo = function () {
            const routeEquipments = route.get('equipmentAssignments');
            let principalEquipment;
            if (routeEquipments) {
              principalEquipment =
                routeEquipments.filter(
                  (equipment) => equipment.principal === true
                )[0] || routeEquipments[0];

              Monet.Session.RouteDetail.screensList[
                routeId
              ].equipment.idOfObject = principalEquipment.equipment.id;
              Monet.Session.RouteDetail.screensList[routeId].equipment.key =
                principalEquipment.equipment.key;
              Monet.Session.RouteDetail.screensList[
                routeId
              ].equipment.gpsUnitId = principalEquipment.equipment.gpsUnitId;
            }

            if(principalEquipment) {
              Greenmile.RouteDetail.Util.renderCaptions(
                route.id,
                [principalEquipment.equipment]
              );
            }
          };

          let ajax = new Monet.Ajax();
          ajax.url =
            'Route/restrictions?criteria={"filters":["id","proactiveRouteOptConfig"]}';
          ajax.method = 'post';
          ajax.data = {
            criteriaChain: [
              {
                and: [
                  {
                    attr: 'id',
                    eq: route.id
                  }
                ]
              }
            ]
          };
          ajax.success = (data) => {
            const hasPro =
              Greenmile.Utils.hasResequenceHistoryPermission() &&
              data?.[0]?.proactiveRouteOptConfig
                ? data[0].proactiveRouteOptConfig
                : null;

            let RouteDetailsTemplate =
              Greenmile.Templates.RouteDetails(hasPro);
            let tab = document.querySelector('#' + tabName);
            let map;
            let containerRouteDetail;

            const bottomBarContainer = document.createElement('div');
            bottomBarContainer.className = 'bottomBarContainer';

            const statusLegendsContainer = document.createElement('div');
            statusLegendsContainer.className = 'status-legends-container';

            const equipmentLegendsContainer = document.createElement('div');
            equipmentLegendsContainer.className = 'equipmentLegendsContainer';

            if (tab) {
              tab.innerHTML = '';
              tab.appendChild(RouteDetailsTemplate);

              map = tab.querySelector('.mapContainer');
              containerRouteDetail = tab.querySelector(
                '.containerRouteDetail'
              );

              if (map) {
                map.id = mapContainer;
              }

              if (containerRouteDetail) {
                bottomBarContainer.appendChild(statusLegendsContainer);
                containerRouteDetail.appendChild(bottomBarContainer);
              }
              setEquipmentInfo();
              initMap();
            }
          };
          ajax.error = function (xhr) {
            Monet.Configurations.errorNotification(null, xhr);
          };
          ajax.send();
        };
      })(
        this.routeId,
        routeCollection
      );

      createTabRoute();
    });

    return this;
  };

  processRouteHasPRO = (routeId, stopId) => {
    let ajax = new Monet.Ajax();
    ajax.url =
      'Route/restrictions?criteria={"filters":["id","proactiveRouteOptConfig"]}';
    ajax.method = "post";
    ajax.data = {
      criteriaChain: [
        {
          and: [
            {
              attr: "id",
              eq: routeId
            }
          ]
        }
      ]
    }
    ajax.success = data => {
      const route = data[0] || {};
      if (Monet.Session.RouteDetail.screensList[routeId]) {
        const hasPRO =
          Greenmile.Utils.hasResequenceHistoryPermission() &&
          route.proactiveRouteOptConfig;
        const routeHasProEnabled =
          Monet.Session.RouteDetail.screensList[routeId].hasPRO;

        if (!routeHasProEnabled && hasPRO) {
          this.show(routeId, stopId);
          Monet.Session.RouteDetail.screensList[routeId].hasPRO = hasPRO;
        }
      }
    };
    ajax.send();
  };

  drawPlannedRoute = (routeId, screen) => {
    for (var key in screen.map._layers) {
      var layer = screen.map._layers[key];
      if (
        layer.kind &&
        layer.kind === "PLANNED_ROUTE" &&
        layer._latlngs.length === 0
      ) {
        var plannedRoute = new Greenmile.RouteDetail.PlannedRoute();
        plannedRoute.setMap(screen.map);
        plannedRoute.setRouteId(routeId);
        plannedRoute.removePlannedRoute();
        plannedRoute.drawPlannedRoute();
      }
    }
  };

  drawBaselinePlannedRoute = (routeId, screen) => {
    for (let key in screen.map._layers) {
      const layer = screen.map._layers[key];
      if (layer.kind && layer.kind === "BASELINE_PLANNED_ROUTE" && layer._latlngs.length === 0) {
        const baselinePlannedRoute = new Greenmile.RouteDetail.BaselinePlannedRoute();
        baselinePlannedRoute.setMap(screen.map);
        baselinePlannedRoute.setRouteId(routeId);
        baselinePlannedRoute.removeBaselinePlannedRoute();
        baselinePlannedRoute.drawBaselinePlannedRoute();
      }
    }
  };

  drawCoords = (routeId, screen, mapPreferences) => {
    var telematicContainer = document.querySelector(
      "#routeMaps_" + routeId + " #routeDetailTelematic"
    );
    if (
      mapPreferences.actual_route ||
      (screen.telematicBuilder && telematicContainer.style.display === "block")
    ) {
      var actualRoute = new Greenmile.RouteDetail.InfoRoute(
        screen.map,
        routeId
      );
      actualRoute.getCoordinatesAndDrawOnMap();
    }
  };

  updateRouteDetailGrid = (routeId, screen) => {
    /**
     * Recupera os stops para preencher a grid, considerando o FILTRO que o usuario fez no filterbuilder
     *
     * @param routeId
     * @param screen
     */

    var filter = this.getFilter();
    var callbackAfterGetStops = function (stopsCollection) {
      App.Views.RouteDetails.showLogBookAndSummaryInformation(
        routeId,
        screen.map
      );
      screen.router.updateGridWithoutRequest(
        stopsCollection,
        Monet.Grid.addDataToGrid
      );
      screen.router.updateOptimizationHistory(routeId);
      if (Greenmile.Utils.hasResequenceHistoryPermission()) {
        screen.router.getResequenceHistory(
          routeId,
          screen.map,
          stopsCollection,
          App.Views.RouteDetails
        );
      }
    };
    screen.router.getStopsByRestrictions(filter, true, callbackAfterGetStops);
  };

  updateOptimizationHistory = routeId => {
    const content = document.querySelector(
      `#routeMaps_${routeId} .containerRouteDetail #panelContainer #routeDetailsModalContent`
    );
    if (content && Greenmile.Utils.hasResequenceHistoryPermission()) {
      const url = `ProactiveRouteOpt/${routeId}`;
      const {
        resequenceHistory: {
          actionCreators: { requestResequenceHistory }
        }
      } = window.actions;
      globalStore.dispatch(requestResequenceHistory({ url, routeId }));
    }
  };

  processMapUpdateByRoute = (routeId, screen) => {
    if (screen) {
      const tabContainer = $(`#routeMaps_${screen.route}`);
      const map = screen.map;

      if (tabContainer.length !== 0 && map) {
        const storage = new Greenmile.Storage.StoreMapPosition();
        const mapPreferences = storage.getLayerMapFromUser();

        this.entityName = `RouteDetails_${routeId}`;
        this.routeId = routeId;
        this.drawPlannedRoute(routeId, screen);
        this.drawBaselinePlannedRoute(routeId, screen);
        this.updateRouteDetailGrid(routeId, screen);
        this.drawCoords(routeId, screen, mapPreferences);

        if (mapPreferences.stops) {
          const markerStops = new Greenmile.RouteDetail.MarkerStop(
            screen.map,
            routeId
          );
          markerStops.getStopsAndDrawOnMap(() => {
            const selectedStopId = Monet.Session.RouteDetail.screensList[routeId].selectedStopId;

            if (selectedStopId) {
              window.globalStore.dispatch({
                type: window.actions.stopDetailsPopup.REQUEST_UPDATE_STOP_DETAILS_POPUP_DATA_STARTED,
                payload: {
                  routeId: routeId,
                  stopId: selectedStopId
                }
              });
            }

            this.updateRadiusAndGeofences(routeId, screen, selectedStopId);
          });
        }
      } else {
        delete Monet.Session.RouteDetail.screensList[routeId];
      }
    }
  };

  processMapUpdates = () => {
    const activeTab = window.globalStore.getState().tabs.get('active');
    const router = activeTab.get('tag');
    const routeDetailsIsActive = router === "RouteDetails";

    if (!routeDetailsIsActive) return;

    const { routeId, childrenId: stopId } = activeTab.get('extra').toJS();
    const screen = Monet.Session.RouteDetail.screensList[routeId];

    if (!screen.hasPRO) {
      this.processRouteHasPRO(routeId, stopId);
    }

    this.updateRouteModel(routeId);
    screen.shouldUpdate = false;
  };

  shouldUpdateAll = value => {
    //Sets shouldUpdate attribute for all Route Details screens that were opened since page was loaded
    const screensList = Monet.Session.RouteDetail.screensList;
    for (const routeId in screensList) {
      screensList[routeId].shouldUpdate = value;
    }
  };

  updateRadiusAndGeofences = (routeId, screen, selectedStopId) => {
    if (screen && screen.stops.data.length) {
      const stopSelection = new Greenmile.RouteDetail.StopSelection(routeId);

      stopSelection.deselectStop(null, true);

      if (selectedStopId) {
        const marker = stopSelection.findStopMarker(selectedStopId);
        marker.selected = true;
        stopSelection.selectStop(selectedStopId);
      } else {
        stopSelection.restoreStopRadiusLayers();
      }
    }
  };

  setRouteId = routeId => {
    this.routeId = routeId;
  };

  getRouteId = () => {
    return this.routeId;
  };

  setStopId = stopId => {
    this.stopId = stopId;
  };

  getStopId = () => {
    return this.stopId;
  };

  updateGrid = (filter, callback, appendCollection) => {
    var error = null;

    try {
      this.getStopsByRestrictions(
        filter,
        appendCollection,
        (function (scope, callback) {
          return function (result) {
            scope.updateGridWithoutRequest(result, callback);
          };
        })(this, callback)
      );
    } catch (e) {
      error = new Monet.Exception.ReturnError(
        this,
        "Error on update route monitoring stops"
      );
      error.console();
    }
  };

  updateResequenceHistoryGrid = (filter, callback) => {
    let error = null;

    try {
      this.getStopsByRestrictions(
        filter,
        appendCollection,
        (function (scope, callback) {
          return function (result) {
            scope.updateGridWithoutRequest(result, callback);
          };
        })(this, callback)
      );
    } catch (e) {
      error = new Monet.Exception.ReturnError(
        this,
        "Error on updating Resequence History grid"
      );
      error.console();
    }
  };

  updateGridWithoutRequest = (result, callback) => {
    var routeDetailOnScreenList =
      Monet.Session.RouteDetail.screensList[this.routeId];

    if (callback && routeDetailOnScreenList) {
      var nameSpace = App.Forms[this.entityName];
      routeDetailOnScreenList.stops.data = result;

      var gridStops = nameSpace.gridStops;
      if (gridStops) {
        gridStops.populateGrid(
          result,
          nameSpace.table.getColumns(),
          nameSpace.table
        );
      }

      var filter = nameSpace.filterBuilder;

      if (filter) {
        filter.loading.hide();
      }
    }
  };

  createGreenmileSessionsToRouteDetail = routeId => {
    this.entityName = "RouteDetails_" + routeId;

    const resequenceEntity = `RouteDetails_${routeId}_ResequenceHistory`;

    if (!Monet.Session.RouteDetail.screensList[routeId]) {
      Monet.Session.RouteDetail.screensList[routeId] = {
        map: {},
        tabSelector: "#routeMaps_" + routeId,
        canMakeCoordinates: true,
        isUpdateAutomatic: true,
        stops: {
          data: {},
          indexes: {},
          layout: {},
          table: {}
        },
        coordinates: new App.Collections.Coordinates(routeId),
        route: routeId,
        model: {},
        router: this,
        actual: {},
        events: {},
        shouldOpenPopup: true,
        markers: {},
        timeoutLayerFocus: [],
        layerFocus: {},
        actualMarkers: [],
        player: {
          isPlaying: false,
          currentMarkerIndex: 0
        },
        mapBaseLayer: {},
        equipments: {},
        routeColor: [
          "#09A129",
          "#6C7AE0",
          "#B3261E",
          "#707070",
          "#AB810A"
        ]
      };
    }

    if (typeof Monet.Session.RouteDetail.gridLayout === "undefined") {
      Monet.Session.RouteDetail.gridLayout = {};
    }

    var options = Monet.Grid.Utils.paginationOptions;

    if (!App.Forms[this.entityName]) {
      App.Forms[this.entityName] = {
        layout: {},
        dataMapper: null,
        pagination: {
          first: options.FIRST,
          max: options.MAX_RESULT,
          blocked: false,
          canIncrement: true
        },
        columnToOrders: [
          {
            field: "stop.plannedSequenceNum",
            order: "ASC"
          }
        ]
      };
    }

    if (!App.Objects[this.entityName]) {
      App.Objects[this.entityName] = this;
      App.Objects[resequenceEntity] = this;
    }
  };

  updateRouteModel = routeId => {
    var callback = (function (scope) {
      return function (routeData) {
        scope.updateEquipments(routeId, routeData);
      };
    })(this);

    if (Monet.Session.RouteDetail.screensList[routeId]) {
      delete Monet.Session.Grids.Route.data;
      this.getRouteData(routeId, callback);
    }
  };

  updateEquipments = (routeId, routeCollection) => {
    if (!Monet.Session.RouteDetail.screensList[routeId]) return;

    const screenlist = Monet.Session.RouteDetail.screensList[routeId];
    const attributes = routeCollection.first().attributes;
    const equipments = attributes.equipmentAssignments ? attributes.equipmentAssignments: {};
    const equipment = this.getEquipmentPrincipal(equipments);

    attributes.principalEquipment = equipment.key ? equipment.key : undefined;
    screenlist.model = attributes;
    screenlist.equipments = {};

    screenlist.equipment = equipment;

    this.processMapUpdateByRoute(routeId, screenlist);
  };

  getEquipmentPrincipal = equipments => {
    if (equipments && equipments.length) {
      var len = equipments.length;
      if (len > 1) {
        for (var i = 0; i < len; i++) {
          if (equipments[i].principal) {
            return {
              idOfObject: equipments[i].equipment.id,
              key: equipments[i].equipment.key,
              gpsUnitId: equipments[i].equipment.gpsUnitId
            };
          }
        }
      } else {
        return {
          idOfObject: equipments[0].equipment.id,
          key: equipments[0].equipment.key,
          gpsUnitId: equipments[0].equipment.gpsUnitId
        };
      }
    } else {
      return {};
    }
  };

  getStopDataToLayers = (routeId, success, customCriteria = []) => {
    const projectionBuilder = new Monet.Builder.Projection();
    const stopView = new App.Collections.StopViews();
    const filter = {
      criteriaChain: [
        {
          and: [
            {
              attr: "route.id",
              eq: routeId
            }
          ]
        }
      ],
      sort: [
        {
          attr: "stop.plannedSequenceNum",
          type: "ASC"
        }
      ]
    };
    projectionBuilder.addFields([{ name: "stop.*" }]);
    customCriteria.forEach(item => {
      projectionBuilder.addField({ name: item });
    });
    stopView.filterWithRestrictions({
      filter,
      criteria: projectionBuilder.projection.toString(),
      success
    });
  };

  addCloseAction = (action) => {
    this.closeActions.push(action);
  };

  removeCloseAction = (actionToRemove) => {
    this.closeActions = this.closeActions.filter((action) => action !== actionToRemove);
  };

  onClose = () => {
    this.closeActions.forEach((action) => action());
  };
}

App.Routers.RouteDetails = RouteDetailsRouter;
